import React from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './terms-conditions.css'

const TermsConditions = (props) => {
  return (
    <div className="terms-conditions-container">
      <Helmet>
        <title>Terms & Conditions</title>
        <meta
          name="description"
          content="Read the terms and conditions that govern your use of our website, products, and services."
        />
        <meta property="og:title" content="Terms &amp; Conditions" />
        <meta
          property="og:description"
          content="Read the terms and conditions that govern your use of our website, products, and services."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/29bbbe6f-6c7b-4302-8334-95a267bd019b/f1e9c444-a5c4-4c2d-bfe3-0d9fba754bc4?org_if_sml=1&amp;force_format=original"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content="Terms &amp; Conditions" />
        <meta
          name="twitter:description"
          content="Read the terms and conditions that govern your use of our website, products, and services."
        />
        <meta
          name="twitter:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/29bbbe6f-6c7b-4302-8334-95a267bd019b/f1e9c444-a5c4-4c2d-bfe3-0d9fba754bc4?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://sudden-pleasant-manatee-mevyzg.teleporthq.site/terms-conditions"
        />
        <meta
          property="og:url"
          content="https://sudden-pleasant-manatee-mevyzg.teleporthq.site/terms-conditions"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://sudden-pleasant-manatee-mevyzg.teleporthq.site"},{"@type":"ListItem","position":2,"name":"Terms-Conditions","item":"https://sudden-pleasant-manatee-mevyzg.teleporthq.site/terms-conditions"}]}',
          }}
        />
      </Helmet>
      <Navigation></Navigation>
      <div
        id="tq-main"
        role="main"
        className="terms-conditions-thq-terms-content-elm"
      >
        <h1 className="terms-conditions-thq-terms-conditions-elm">
          Terms &amp; Conditions
        </h1>
        <p className="terms-conditions-thq-last-updated-september92026-elm">
          Last updated: September 9, 2026
        </p>
        <p className="terms-conditions-thq-please-read-these-terms-conditions-carefully-before-usi-elm">
          Please read these Terms &amp; Conditions carefully before using our
          website. By accessing or using any part of the site, you agree to be
          bound by these Terms. If you do not agree to all the terms and
          conditions of this agreement, you may not access the website or use
          any of its services.
        </p>
        <h2 className="terms-conditions-thq1-acceptance-of-terms-elm">
          1. Acceptance of Terms
        </h2>
        <p className="terms-conditions-thq-by-accessing-and-using-this-website-you-confirm-that-you-elm">
          By accessing and using this website, you confirm that you are at least
          18 years of age, have read and understood these Terms &amp;
          Conditions, and agree to be legally bound by them. If you are using
          this website on behalf of a company or other legal entity, you
          represent that you have the authority to bind that entity to these
          Terms. These Terms apply to all visitors, users, and others who access
          or use the website.
        </p>
        <h2 className="terms-conditions-thq2-definitions-elm">
          2. Definitions
        </h2>
        <p className="terms-conditions-thq-website-refers-to-all-pages-features-and-content-acce-elm">
          &quot;Website&quot; refers to all pages, features, and content
          accessible at this domain and any associated subdomains.
          &quot;Services&quot; refers to any functionality, content, products,
          or tools offered through the website. &quot;User,&quot;
          &quot;you,&quot; and &quot;your&quot; refer to anyone who accesses or
          uses the website. &quot;We,&quot; &quot;us,&quot; and &quot;our&quot;
          refer to the website owner and operator. &quot;Content&quot; means any
          text, images, audio, video, software, data, or other material
          available on the website.
        </p>
        <h2 className="terms-conditions-thq3-use-of-the-website-elm">
          3. Use of the Website
        </h2>
        <p className="terms-conditions-thq-you-agree-to-use-this-website-only-for-lawful-purposes-an-elm">
          You agree to use this website only for lawful purposes and in a manner
          that does not infringe the rights of others. You must not use the
          website to transmit unsolicited commercial communications, to engage
          in fraudulent activity, to distribute malicious software, to attempt
          unauthorized access to any systems or networks, or to engage in any
          conduct that restricts or inhibits anyone else&apos;s use of the
          website. We reserve the right to terminate or restrict your access to
          the website at any time without notice for any reason.
        </p>
        <h2 className="terms-conditions-thq4-intellectual-property-elm">
          4. Intellectual Property
        </h2>
        <p className="terms-conditions-thq-all-content-on-this-website-including-but-not-limited-to-elm">
          All content on this website, including but not limited to text,
          graphics, logos, images, audio clips, digital downloads, data
          compilations, and software, is the property of the website owner or
          its content suppliers and is protected by applicable intellectual
          property laws. You may not reproduce, modify, distribute, transmit,
          display, perform, publish, license, create derivative works from,
          transfer, or sell any information or content obtained from this
          website without express prior written permission. Any unauthorized use
          may violate copyright, trademark, privacy, and other laws.
        </p>
        <h2 className="terms-conditions-thq5-user-submitted-content-elm">
          5. User-Submitted Content
        </h2>
        <p className="terms-conditions-thq-if-you-submit-post-or-upload-any-content-to-this-websit-elm">
          If you submit, post, or upload any content to this website, you grant
          us a non-exclusive, worldwide, royalty-free, perpetual, irrevocable,
          and fully sublicensable license to use, reproduce, modify, adapt,
          publish, translate, create derivative works from, distribute, and
          display such content. You represent and warrant that you own or have
          the necessary rights to the content you submit and that such content
          does not infringe any third-party rights. We reserve the right to
          remove any user-submitted content at our sole discretion without
          notice.
        </p>
        <h2 className="terms-conditions-thq6-privacy-policy-and-data-protection-elm">
          6. Privacy Policy and Data Protection
        </h2>
        <p className="terms-conditions-thq-your-use-of-this-website-is-also-governed-by-our-privacy-elm">
          Your use of this website is also governed by our Privacy Policy, which
          is incorporated by reference into these Terms. By using the website,
          you consent to the collection and use of your information as described
          in our Privacy Policy. We implement reasonable technical and
          organizational measures to protect your personal data against
          accidental or unlawful destruction, loss, or unauthorized access.
          However, no data transmission over the internet can be guaranteed to
          be 100% secure, and we cannot guarantee absolute security. Anonymous,
          aggregated website usage statistics (see the Website Analytics section
          below) are processed on the basis of our legitimate interest in
          understanding and improving this website.
        </p>
        <h2 className="terms-conditions-thq7-cookie-policy-elm">
          7. Cookie Policy
        </h2>
        <p className="terms-conditions-thq-this-website-uses-cookies-and-similar-tracking-technologi-elm">
          This website uses cookies and similar tracking technologies to enhance
          your experience, remember your preferences, analyze traffic, and
          deliver personalized content. Cookies are small text files placed on
          your device. By continuing to use this website, you consent to our use
          of cookies. Essential cookies are strictly necessary for the website
          to function and cannot be disabled. Preference cookies may be declined
          through your browser settings or our cookie consent banner. Our
          first-party visitor analytics operates without cookies by default; if
          you accept analytics storage via the consent banner, a randomly
          generated anonymous identifier may be stored in your browser&apos;s
          local storage solely to recognize returning visits to this website.
          This identifier contains no personal information and is never used
          across other websites. We are not responsible for the cookie practices
          of any third-party services linked from or integrated into this
          website.
        </p>
        <h2 className="terms-conditions-thq8-website-analytics-elm">
          8. Website Analytics
        </h2>
        <p className="terms-conditions-thq-this-website-uses-a-privacy-focused-first-party-analytic-elm">
          This website uses a privacy-focused, first-party analytics service to
          understand aggregate visitor behavior, such as the number of visitors,
          the pages they view, how long they stay, the country and region they
          visit from, the type of device and browser they use, the website that
          referred them, and interactions such as link and button clicks. We use
          this information solely to measure and improve the performance and
          content of this website. The data we collect is anonymous: we do not
          record names, email addresses, or any other personally identifying
          information; full IP addresses are processed only momentarily in
          memory to derive an approximate location and an anonymized daily
          identifier, and are never stored; the anonymization key rotates every
          24 hours, after which an individual visitor can no longer be
          re-identified. No analytics data is shared with advertising networks,
          used to build profiles of you, or used to track you across other
          websites. Aggregated statistics are retained only for as long as
          needed for the purposes described above, and the underlying anonymized
          visit records are automatically deleted after at most ninety (90)
          days. If you wish to object to this processing, you may decline
          analytics in the cookie consent banner where available, use a
          content-blocking browser extension, or contact us using the contact
          information provided on this website.
        </p>
        <h2 className="terms-conditions-thq9-third-party-links-and-services-elm">
          9. Third-Party Links and Services
        </h2>
        <p className="terms-conditions-thq-this-website-may-contain-links-to-third-party-websites-s-elm">
          This website may contain links to third-party websites, services, or
          resources. These links are provided for your convenience only. We have
          no control over the content, privacy policies, or practices of any
          third-party sites and accept no responsibility or liability for them.
          You access any third-party site entirely at your own risk. We do not
          endorse or make any representation about third-party sites, their
          content, or any results that may be obtained from using them. Any
          transactions you conduct with third parties found on or through this
          website are solely between you and that third party.
        </p>
        <h2 className="terms-conditions-thq10-third-party-service-providers-artificial-intelligenc-elm">
          10. Third-Party Service Providers, Artificial Intelligence, and Data
          Processing
        </h2>
        <p className="terms-conditions-thq-to-operate-this-website-and-provide-its-features-we-rely-elm">
          To operate this website and provide its features, we rely on a range
          of third-party service providers, infrastructure, and integrations.
          These may include, among others, hosting and content-delivery
          networks, payment processors, database and storage providers, email
          and communication services, analytics tools, and similar services. In
          addition, certain features of this website — including, where
          applicable, AI assistant or chat functionality and automated workflows
          — are powered by third-party artificial intelligence and
          machine-learning providers, such as OpenAI, Anthropic, Google, Cohere,
          Mistral AI, Meta, and Perplexity, among others. When you use the
          website and these features, the information you provide — including
          messages, prompts, uploaded files, submitted content, and related
          technical data — may be transmitted to, stored by, and processed by
          these third-party providers on their own systems, which may be located
          in countries other than your own, and is subject to those
          providers&apos; own terms of service and privacy policies. We do not
          control, and accept no responsibility or liability for, the manner in
          which these third-party providers collect, use, retain, transfer, or
          otherwise process your data, the jurisdictions to which your data may
          be transferred, or the purposes for which they use it. The third-party
          providers and services we use may be added to, removed, replaced, or
          otherwise change at any time without notice, and these Terms are
          intended to apply to all such current and future providers and
          services, whether or not they are individually named here. By
          continuing to access or use this website and its features, you
          acknowledge and expressly consent to the transmission, storage, and
          processing of your data by these third-party services, and you accept
          sole responsibility for that data flow. If you do not agree to your
          data being handled in this way, you must stop using the website and
          the affected features immediately.
        </p>
        <h2 className="terms-conditions-thq11-disclaimer-of-warranties-elm">
          11. Disclaimer of Warranties
        </h2>
        <p className="terms-conditions-thq-thiswebsiteandallcontentservicesandmaterialsava-elm">
          THIS WEBSITE AND ALL CONTENT, SERVICES, AND MATERIALS AVAILABLE
          THROUGH IT ARE PROVIDED &quot;AS IS&quot; AND &quot;AS
          AVAILABLE,&quot; WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND
          NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE WEBSITE WILL BE
          UNINTERRUPTED, ERROR-FREE, SECURE, OR FREE OF VIRUSES OR OTHER HARMFUL
          COMPONENTS. WE MAKE NO WARRANTY REGARDING THE ACCURACY, COMPLETENESS,
          RELIABILITY, OR TIMELINESS OF ANY CONTENT OR INFORMATION ON THE
          WEBSITE. YOUR USE OF THE WEBSITE IS AT YOUR SOLE RISK.
        </p>
        <h2 className="terms-conditions-thq12-limitation-of-liability-elm">
          12. Limitation of Liability
        </h2>
        <p className="terms-conditions-thq-tothefullestextentpermittedbyapplicablelawinno-elm">
          TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
          THE WEBSITE OWNER, OPERATORS, AFFILIATES, LICENSORS, SERVICE
          PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR ANY
          INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, OR EXEMPLARY
          DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, REVENUE, DATA,
          GOODWILL, OR OTHER INTANGIBLE LOSSES, ARISING OUT OF OR RELATED TO
          YOUR USE OF, OR INABILITY TO USE, THIS WEBSITE OR ITS CONTENT, EVEN IF
          ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN NO EVENT SHALL OUR
          TOTAL LIABILITY TO YOU FOR ALL CLAIMS EXCEED THE GREATER OF ONE
          HUNDRED DOLLARS ($100) OR THE AMOUNT PAID BY YOU TO US IN THE TWELVE
          MONTHS PRECEDING THE CLAIM. SOME JURISDICTIONS DO NOT ALLOW THE
          EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE
          ABOVE LIMITATIONS MAY NOT APPLY TO YOU.
        </p>
        <h2 className="terms-conditions-thq13-indemnification-elm">
          13. Indemnification
        </h2>
        <p className="terms-conditions-thq-you-agree-to-defend-indemnify-and-hold-harmless-the-web-elm">
          You agree to defend, indemnify, and hold harmless the website owner,
          its affiliates, licensors, service providers, employees, agents,
          officers, and directors from and against any claims, liabilities,
          damages, judgments, awards, losses, costs, expenses, or fees
          (including reasonable legal fees) arising out of or relating to your
          violation of these Terms, your use of the website, your submission of
          any content, your violation of any third-party rights, or your
          violation of any applicable law. We reserve the right, at our expense,
          to assume exclusive defense and control of any matter subject to
          indemnification by you.
        </p>
        <h2 className="terms-conditions-thq14-force-majeure-elm">
          14. Force Majeure
        </h2>
        <p className="terms-conditions-thq-we-shall-not-be-held-liable-for-any-failure-or-delay-in-p-elm">
          We shall not be held liable for any failure or delay in performance of
          our obligations under these Terms arising from causes beyond our
          reasonable control, including but not limited to acts of God, natural
          disasters, pandemics, epidemics, war, terrorism, civil unrest,
          governmental action, internet failures, power outages, cyberattacks,
          or any other events outside our reasonable control. In such
          circumstances, our obligations will be suspended for the duration of
          the event.
        </p>
        <h2 className="terms-conditions-thq15-accuracy-and-errors-elm">
          15. Accuracy and Errors
        </h2>
        <p className="terms-conditions-thq-we-make-reasonable-efforts-to-ensure-that-the-content-on-elm">
          We make reasonable efforts to ensure that the content on this website
          is accurate and up to date, but we do not guarantee its accuracy,
          completeness, or suitability for any particular purpose. Information
          on the website may include typographical errors, inaccuracies, or
          outdated information. We reserve the right to correct any errors,
          inaccuracies, or omissions and to change or update information at any
          time without prior notice. We are not responsible for any decisions
          made based on information found on this website.
        </p>
        <h2 className="terms-conditions-thq16-age-restrictions-elm">
          16. Age Restrictions
        </h2>
        <p className="terms-conditions-thq-this-website-is-not-directed-to-or-intended-for-use-by-in-elm">
          This website is not directed to or intended for use by individuals
          under the age of 18, or the applicable age of majority in their
          jurisdiction. We do not knowingly collect personal information from
          minors. If you are a parent or guardian and believe that your child
          has provided us with personal information without your consent, please
          contact us immediately so we can take appropriate action.
        </p>
        <h2 className="terms-conditions-thq17-no-professional-advice-elm">
          17. No Professional Advice
        </h2>
        <p className="terms-conditions-thq-nothing-on-this-website-constitutes-legal-financial-med-elm">
          Nothing on this website constitutes legal, financial, medical, tax, or
          other professional advice. The content is provided for general
          informational purposes only. You should not rely on any information on
          this website as a substitute for professional advice from a qualified
          practitioner in the relevant field. We expressly disclaim all
          liability for any actions taken or not taken based on the content of
          this website.
        </p>
        <h2 className="terms-conditions-thq18-modifications-to-terms-elm">
          18. Modifications to Terms
        </h2>
        <p className="terms-conditions-thq-we-reserve-the-right-to-revise-and-update-these-terms-c-elm">
          We reserve the right to revise and update these Terms &amp; Conditions
          at any time at our sole discretion. Changes will take effect
          immediately upon posting to the website. Your continued use of the
          website after any modifications constitutes your binding acceptance of
          the updated Terms. It is your responsibility to review these Terms
          periodically. If you do not agree with the revised Terms, you must
          immediately stop using the website.
        </p>
        <h2 className="terms-conditions-thq19-termination-elm">
          19. Termination
        </h2>
        <p className="terms-conditions-thq-we-may-terminate-or-suspend-your-access-to-the-website-im-elm">
          We may terminate or suspend your access to the website immediately,
          without prior notice or liability, for any reason, including if you
          breach these Terms. Upon termination, all licenses and rights granted
          to you under these Terms will immediately cease. Provisions of these
          Terms that by their nature should survive termination shall survive,
          including ownership provisions, warranty disclaimers, indemnification,
          and limitations of liability.
        </p>
        <h2 className="terms-conditions-thq20-governing-law-and-jurisdiction-elm">
          20. Governing Law and Jurisdiction
        </h2>
        <p className="terms-conditions-thq-these-terms-conditions-shall-be-governed-by-and-constru-elm">
          These Terms &amp; Conditions shall be governed by and construed in
          accordance with applicable law, without regard to its conflict of law
          provisions. Any disputes arising from or relating to these Terms or
          your use of the website shall be subject to the exclusive jurisdiction
          of the competent courts in the applicable jurisdiction. If any
          provision of these Terms is held to be invalid or unenforceable, that
          provision shall be modified to the minimum extent necessary to make it
          enforceable, and the remaining provisions shall continue in full force
          and effect.
        </p>
        <h2 className="terms-conditions-thq21-dispute-resolution-elm">
          21. Dispute Resolution
        </h2>
        <p className="terms-conditions-thq-before-initiating-any-formal-legal-proceedings-you-agree-elm">
          Before initiating any formal legal proceedings, you agree to first
          contact us in good faith and attempt to resolve any dispute
          informally. If the dispute cannot be resolved informally within thirty
          (30) days, either party may pursue their rights through the
          appropriate legal channels. You agree that any dispute resolution
          proceedings will be conducted on an individual basis only, and not as
          a class or representative action. You waive any right to participate
          in a class-action lawsuit or class-wide arbitration.
        </p>
        <h2 className="terms-conditions-thq22-severability-and-waiver-elm">
          22. Severability and Waiver
        </h2>
        <p className="terms-conditions-thq-if-any-provision-of-these-terms-is-found-to-be-unenforcea-elm">
          If any provision of these Terms is found to be unenforceable or
          invalid, that provision will be limited or eliminated to the minimum
          extent necessary so that the remaining Terms remain in full force and
          effect. Our failure to enforce any right or provision of these Terms
          will not be deemed a waiver of such right or provision. A waiver of
          any particular breach will not constitute a waiver of any subsequent
          breach.
        </p>
        <h2 className="terms-conditions-thq23-entire-agreement-elm">
          23. Entire Agreement
        </h2>
        <p className="terms-conditions-thq-these-terms-conditions-together-with-our-privacy-polic-elm">
          These Terms &amp; Conditions, together with our Privacy Policy and any
          other legal notices published by us on the website, constitute the
          entire agreement between you and us concerning your use of the website
          and supersede all prior agreements and understandings, whether written
          or oral, regarding such subject matter. No oral or written information
          or advice provided by us or our representatives shall create any
          warranty or otherwise alter the scope of these Terms.
        </p>
        <h2 className="terms-conditions-thq24-contact-information-elm">
          24. Contact Information
        </h2>
        <p className="terms-conditions-thq-if-you-have-any-questions-concerns-or-requests-regardin-elm">
          If you have any questions, concerns, or requests regarding these Terms
          &amp; Conditions, our Privacy Policy, or the handling of your personal
          data, please contact us through the contact information provided on
          this website. We aim to respond to all inquiries within a reasonable
          timeframe. For legal notices, please clearly indicate the nature of
          the matter in your communication.
        </p>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default TermsConditions
